import type { UpdateSynthesisSessionInput } from "../entities/synthesis-session"
import type { SynthesisSessionRepository } from "../repositories/synthesis-session-repository"

export const makeUpdateSynthesisSession = (
  repo: SynthesisSessionRepository,
) => (id: string, input: UpdateSynthesisSessionInput) =>
  repo.update(id, input)
